import { INavData } from '../../shared/shared.module'

export const navItems: INavData[] = [
  {
    title: true,
    nameKey: 'nav.personal',
    name: '個人',
    roles: ['user']
  },
   {
    nameKey: 'nav.imaginus',
    name: 'IMAGINUS',
    url: '/home',
    iconComponent: { name: 'cil-terminal' },
    roles: ['user'],
    children: [],
  },
  {
    navId: 'admin',
    nameKey: 'nav.admin',
    name: '管理員',
    iconComponent: { name: 'cil-user' },
    url: '/admin',
    roles: ['admin'],
    children: [
      {
        navId: 'admin_user_dashboard',
        nameKey: 'nav.admin_user_dashboard',
        name: '用戶管理儀表板',
        url: '/admin/user_dashboard/users',
        icon: 'nav-icon-bullet',
      },
      {
        navId: 'admin_server_dashboard',
        nameKey: 'nav.admin_server_dashboard',
        name: '伺服器狀態儀表板',
        url: '/admin/server_dashboard/overview',
        icon: 'nav-icon-bullet',
      },
      {
        navId: 'admin_ht1',
        nameKey: 'nav.admin_ht1',
        name: 'HT1 設備管理',
        url: '/admin/ht1_device_manager',
        icon: 'nav-icon-bullet',
      },
      {
        navId: 'admin_electricity_platform',
        nameKey: 'nav.admin_electricity_platform',
        name: '用電變更平台設定',
        url: '/admin/electricity_platform_settings',
        icon: 'nav-icon-bullet',
      },
      {
        navId: 'admin_backend_billing',
        nameKey: 'nav.admin_backend_billing',
        name: '後台帳務',
        url: '/admin/backend_billing',
        icon: 'nav-icon-bullet',
      }
    ],
  },
  {
    navId: 'tasks',
    nameKey: 'nav.tasks',
    name: '待辦事項',
    url: '/task-manager',
    iconComponent: { name: 'cil-calendar-check' },
    roles: ['user']
  },
  {
    navId: 'device_live',
    nameKey: 'nav.device_live',
    name: '即時狀態',
    url: '/device/view',
    roles: ['project leader', 'eng', 'warehouse'],
    iconComponent: { name: 'cil-compass' }
  },
  {
    navId: 'device_history',
    nameKey: 'nav.device_history',
    name: '歷史資料',
    url: '/device/history',
    roles: ['admin', 'project leader', 'eng', 'warehouse'],
    iconComponent: { name: 'cil-book' }
  },
  {
    navId: 'lan_installer',
    nameKey: 'nav.lan_installer',
    name: '軟體安裝',
    url: '/inventory/lan-installer',
    iconComponent: { name: 'cil-home' },
    roles: ['admin', 'warehouse']
  },
  {
    navId: 'documents',
    nameKey: 'nav.documents',
    name: '文書案件',
    url: '/documentDemands',
    iconComponent: { name: 'cil-pen' },
    roles: ['TPC_Officer']
  },
];
